const localFlag = 0;
var config = {};

// config.backend = `https://admin-services.azurewebsites.net/`;
config.backend = `https://admin-backend.navigators.org.sg/`;
// config.backend = `https://admin-backend-staging.azurewebsites.net/`;
// config.reservebackend = `https://reserve-backend-reserve-backend-staging.azurewebsites.net`;
config.reservebackend = `https://reserve-backend.azurewebsites.net`;
// config.reservebackend = `https://reserve-backend-staging.azurewebsites.net`;
// config.website = "https://admin-services-frontend.azurewebsites.net";
config.website = "https://admin-service.navigators.org.sg";
// config.website = "https://admin-frontend-staging.azurewebsites.net";

if (localFlag) {
    // config.homepath = '';
    config.homepath = './';
    config.backend = `http://localhost:4000/`;
    config.reservebackend = `http://localhost:9000`;
    config.website = `http://localhost:3000`;
}

config.debug = false;

config.params = {}

config.params.monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


config.ServiceBus = {}
config.ServiceBus.connectionString = "Endpoint=sb://staffreserve.servicebus.windows.net/;SharedAccessKeyName=RootManageSharedAccessKey;SharedAccessKey=hNUhCS9sf81iQn238AFqrDrF+bWXrN3fDDet95kvFYE=";

config.start_year = 2018;

module.exports = config;
